<template>
    <div class="calendar-star-icon" :class="`calendar-star-icon-${props.size}`">
        <i class="bi bi-calendar calendar-star-icon-glyph" aria-hidden="true"></i>
        <div class="calendar-star-icon-badge">
            <svg aria-hidden="true" class="calendar-star-icon-star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
                <path d="M6 0L7.35 4.65L12 6L7.35 7.35L6 12L4.65 7.35L0 6L4.65 4.65L6 0Z" fill="#595959" />
            </svg>
        </div>
    </div>
</template>

<script setup lang="ts">
type IconSize = "sm" | "md";

interface Props {
    size?: IconSize;
}

const props = withDefaults(defineProps<Props>(), {
    size: "md",
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .calendar-star-icon {
        @apply relative;
    }
    .calendar-star-icon-glyph {
        @apply text-[#595959];
    }
    .calendar-star-icon-badge {
        @apply absolute right-0 bg-white;
    }

    .calendar-star-icon-md {
        @apply size-7;
        .calendar-star-icon-glyph {
            @apply text-[26px];
        }
        .calendar-star-icon-badge {
            @apply top-1;
        }
        .calendar-star-icon-star {
            @apply size-3;
        }
    }

    .calendar-star-icon-sm {
        @apply size-5;
        .calendar-star-icon-glyph {
            @apply text-[18px];
        }
        .calendar-star-icon-badge {
            @apply top-[3px];
        }
        .calendar-star-icon-star {
            @apply size-2;
        }
    }
}
</style>
